<template>
    <header :class="headerClass" ref="header"
        class="header fixed h-[80px] top-[0] left-[0] w-full p-[20px] z-[10] flex justify-end transition">
        <button v-if="$store.state.resultView" @click="$store.commit('reset')"
            class="w-[40px] h-[40px] border flex items-center justify-center">
            <font-awesome-icon icon="fa-regular fa-rotate-right" />
        </button>

        <div class="absolute top-[20px] z-10 left-[50%] translate-x-[-50%]">
            <div class="cursor-pointer" ref="logo" @click="$store.commit('reset')">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="99.59"
                    height="40" viewBox="0 0 99.59 40">
                    <defs>
                        <clipPath id="clip-path">
                            <rect id="Rectangle_10663" data-name="Rectangle 10663" width="99.59" height="40"
                                fill="#01338d" />
                        </clipPath>
                    </defs>
                    <g id="Group_11385" data-name="Group 11385" transform="translate(-286 -92)">
                        <g id="Group_11384" data-name="Group 11384" transform="translate(286 92)">
                            <g id="Group_11383" data-name="Group 11383" transform="translate(0 0)">
                                <g id="Group_11382" data-name="Group 11382" clip-path="url(#clip-path)">
                                    <path ref="path" id="Path_15" data-name="Path 15"
                                        d="M98.81,30.45H93.636l.855-3.422H84.123l-.852,3.422h-5.01v-.7c.077-.386.144-.79.241-1.222.911-3.69,3.334-7.336,7.524-7.336,1.658,0,3.306.632,3.08,2.925h6.168a5.472,5.472,0,0,0-.513-4.569c-1.315-1.821-3.963-2.552-7.4-2.552a16.772,16.772,0,0,0-9.1,2.406V.788H98.81ZM86.684,35.463a19.645,19.645,0,0,1-3.455.353c-2.962,0-5.023-1.377-5.066-4.589h9.572ZM74.843,18.52l-.01,4.252a17.142,17.142,0,0,0-2.737,5.88,11.871,11.871,0,0,0-.327,1.8H68.75L71.33,18.2,62.644,18.2,54.87,30.45H54.3V.788H74.843ZM63.373,30.45h-3.09l4.677-7.359ZM50.9,18.175h-5.14L42.236,30.45H36.785a7.327,7.327,0,0,0,4.99-5.9c.431-2.262.226-3.751-.7-4.866-1.383-1.658-4.158-1.517-6.623-1.517l-4.077.008V.788H50.9ZM47.615,30.45l2.163-7.679.076,7.679Zm-14.948-2.92h-.006c-.2.01-.4.027-.629.027-.3,0-.534.011-.755.011l-1.314-.011.608-2.247.287-1.116.69-2.614c.305,0,.605-.011.891-.011h1.018c1.737,0,2.836.1,3.235.657.307.419.267,1.144-.095,2.247-.62,1.9-1.4,2.863-3.931,3.056m-5.709-8.268-.322,1.066L23.7,30.106l-.116.344h-9.67l-.755-1.593L23.582,18.2h-6.7L8.732,26.985,11.372,18.2H6.434V.788H26.958ZM77.481,0V19.96a13.508,13.508,0,0,0-1.843,1.776V0H53.529V18.175H51.7V0H29.584V18.2h-1.83V0H5.641V20.748L0,39.559H4.962l2.493-8.331h.717l4.115,8.331h6l-3.993-8.331h9.06l-2.514,8.331h5.423l2.48-8.308h1.19v-.024H42l-2.394,8.307h5.467l2.32-8.307h2.46l.066,8.307h4.587l5.264-8.307h3.447L61.44,39.535h5.383l1.746-8.307h3.113a8.012,8.012,0,0,0,2.242,6.489C76.01,39.634,79.213,40,81.584,40a45.794,45.794,0,0,0,10-1.229l1.865-7.543H99.59V0Z"
                                        fill="#FFFFFF" />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
        </div>

        <Navigation />
    </header>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import { gsap } from 'gsap';

export default {
    name: 'HeaderSection',
    components: {
        Navigation,
    },
    computed: {
        headerClass() {
            return !this.$store.state.helloView ? 'bg-white' : '';
        },
    },
    watch: {
        '$store.state.helloView': function () {
            const logoRect = this.$refs.logo.getBoundingClientRect();

            const move = (logoRect.x * -1) + 20

            gsap.to(this.$refs.logo, .3, {
                x: move,
            });

            gsap.to(this.$refs.path, .3, {
                fill: this.$store.state.helloView ? '#FFFFFF' : '#01338d'
            });
            
        },
    }
}
</script>